export default __webpack_public_path__ + "static/1-3df0a32a3c5ccd8d70c9abfeb15c3e6f.png";